function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 1a6 6 0 106 6c0-.696-.126-1.386-.366-2.034l-.96.96c.084.354.126.714.126 1.074A4.8 4.8 0 117 2.2c.36 0 .72.042 1.074.126l.966-.966A6.061 6.061 0 007 1zm4.2 0L8.8 3.4v.9L7.27 5.83C7.18 5.8 7.09 5.8 7 5.8A1.2 1.2 0 108.2 7c0-.09 0-.18-.03-.27L9.7 5.2h.9L13 2.8h-1.8V1zM7 3.4A3.6 3.6 0 1010.6 7H9.4A2.4 2.4 0 117 4.6V3.4z",
  fill: "currentColor"
});

var SvgEffective = function SvgEffective(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgEffective;